export const Roles = {
  Admin: "PlusBus Administrator",
  SchemeCoordinator: "PlusBus Scheme Coordinator",
};
